import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';
import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.overlay,
      justifyContent: 'flex-end',
    },
    safeareaContainer: {
      backgroundColor: colors.surface,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      maxHeight: '90%',
    },
    bottomContainer: {
      padding: 24,
    },
    selectedChecBoxTitle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 18,
      color: colors.textPrimary,
    },
    normalChecBoxTitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 18,
      color: colors.textMuted,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 32,
    },
    button: {
      flex: 1,
    },
    mt24: {
      marginTop: 24,
    },
    ml16: {
      marginLeft: 16,
    },
    checkbox: {
      width: 17,
      height: 17,
    },
    webContainer: {
      ...CommonStyles.full_flex,
      ...CommonStyles.flex_center,
      backgroundColor: colors.overlayLight,
    },
    webSafeareaContainer: {
      backgroundColor: colors.surface,
      ...CommonStyles.br_16,
      maxHeight: '90%',
      maxWidth: 481,
    },
  });

export default makeStyles;
